import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
const getCases = (t: any) => [{
  industry: t('case_1_ind'),
  challenge: t('case_1_chal'),
  metric: '↓ 65%',
  metricLabel: t('case_1_met_label'),
  title: t('case_1_title')
}, {
  industry: t('case_2_ind'),
  challenge: t('case_2_chal'),
  metric: '↑ 340%',
  metricLabel: t('case_2_met_label'),
  title: t('case_2_title')
}, {
  industry: t('case_3_ind'),
  challenge: t('case_3_chal'),
  metric: '$2.4M',
  metricLabel: t('case_3_met_label'),
  title: t('case_3_title')
}];
export function CaseStudies() {
  const {
    t
  } = useLanguage();
  const cases = getCases(t);
  return <section id="case-studies" className="py-24 bg-white" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-16">
          <div className="max-w-2xl" data-id="element-17">
            <motion.h2 className="text-4xl font-extrabold text-navy mb-4" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-18">
              {t('case_title')}
            </motion.h2>
            <motion.p className="text-lg text-slate-600" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} data-id="element-19">
              {t('case_desc')}
            </motion.p>
          </div>
          <motion.a href="#all-cases" className="hidden md:inline-flex items-center gap-2 text-electric font-semibold hover:text-electric-hover transition-colors" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-20">
            {t('case_view_all')} <ArrowRightIcon className="w-5 h-5" data-id="element-21" />
          </motion.a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-23">
              {/* Top Accent */}
              <div className="h-2 w-full bg-electric transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-24" />

              <div className="p-8 flex flex-col flex-1" data-id="element-25">
                <div className="mb-6" data-id="element-26">
                  <span className="inline-block px-3 py-1 bg-slate-100 text-navy text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-27">
                    {item.industry}
                  </span>
                  <h3 className="text-xl font-bold text-navy mb-3" data-id="element-28">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-29">
                    <span className="font-semibold text-slate-800" data-id="element-30">
                      {t('case_challenge')}
                    </span>{' '}
                    {item.challenge}
                  </p>
                </div>

                <div className="mt-auto pt-6 border-t border-slate-100" data-id="element-31">
                  <div className="text-4xl font-extrabold text-electric mb-1" data-id="element-32">
                    {item.metric}
                  </div>
                  <div className="text-sm font-medium text-slate-500 mb-6" data-id="element-33">
                    {item.metricLabel}
                  </div>

                  <a href="#read-more" className="inline-flex items-center text-sm font-bold text-navy group-hover:text-electric transition-colors" data-id="element-34">
                    {t('case_read_full')}{' '}
                    <ArrowRightIcon className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-35" />
                  </a>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}